import React from 'react';
import { toast, cssTransition } from 'react-toastify';

export const Fade = cssTransition({
    enter: 'app-toast-fade-in',
    exit: 'app-toast-fade-out',
});

const RichBody = ({ title, body, image, clickable }) => (
    <div className={`app-toast ${clickable ? 'app-toast--clickable' : ''}`}>
        {image && <img src={image} alt="" className="app-toast__image" />}
        <div className="app-toast__content">
            {title && <div className="app-toast__title">{title}</div>}
            {body && <div className="app-toast__body">{body}</div>}
        </div>
    </div>
);

const notify = ({ title, body, image, link, type, onClick, ...options } = {}) => {
    const clickable = Boolean(link || onClick);

    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
            return;
        }
        if (link) window.location.href = link;
    };

    const fn = type && typeof toast[type] === 'function' ? toast[type] : toast;

    return fn(
        <RichBody title={title} body={body} image={image} clickable={clickable} />,
        {
            onClick: clickable ? handleClick : undefined,
            ...options,
        }
    );
};

const appToast = Object.assign(notify, {
    notify,
    success: (msg, opts) => toast.success(msg, opts),
    error:   (msg, opts) => toast.error(msg, opts),
    info:    (msg, opts) => toast.info(msg, opts),
    warning: (msg, opts) => toast.warning(msg, opts),
    dismiss: (id) => toast.dismiss(id),
});

export { toast };
export default appToast;
